import { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Check, Copy, Download, Share2 } from "lucide-react";
import { toast } from "sonner";

export const ReferralCard = ({ distId, name }) => {
  const link = `${window.location.origin}/registro?ref=${distId}`;
  const [copied, setCopied] = useState(false);
  const wrap = useRef(null);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Enlace copiado");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("No se pudo copiar. Selecciona el enlace manualmente.");
    }
  };

  const download = () => {
    const canvas = wrap.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `qr-hpf-${distId}.png`;
    a.click();
  };

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "Únete a mi red en Happy People Factory", text: `${name} te invita a Happy People Factory`, url: link });
      } catch {
        /* cancelado */
      }
    } else copy();
  };

  return (
    <div className="grid gap-6 rounded-[1.5rem] border border-ink/10 bg-white p-6 sm:grid-cols-[auto_1fr] sm:items-center" data-testid="referral-card">
      <div ref={wrap} className="mx-auto rounded-2xl border border-ink/10 bg-white p-3" data-testid="referral-qr">
        <QRCodeCanvas value={link} size={168} level="M" includeMargin={false} fgColor="#0A1230" />
      </div>
      <div className="min-w-0">
        <p className="font-mono text-xs uppercase tracking-[0.14em] text-leaf-deep">Tu enlace y código QR de invitación</p>
        <p className="mt-2 text-sm text-ink/70">Quien se registre con este enlace o escaneando tu QR quedará automáticamente en tu red con tu ID <span className="font-mono font-semibold text-ink">{distId}</span>.</p>
        <p className="mt-3 break-all rounded-xl bg-paper px-3.5 py-2.5 font-mono text-xs text-ink" data-testid="referral-link">{link}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          <button onClick={copy} className="btn-ink !px-4 !py-2.5 !text-xs" data-testid="referral-copy">
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />} Copiar enlace
          </button>
          <button onClick={download} className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-4 py-2.5 text-xs font-semibold hover:bg-paper" data-testid="referral-download-qr">
            <Download className="h-4 w-4" /> Descargar QR
          </button>
          <button onClick={share} className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-4 py-2.5 text-xs font-semibold hover:bg-paper" data-testid="referral-share">
            <Share2 className="h-4 w-4" /> Compartir
          </button>
        </div>
      </div>
    </div>
  );
};
